import React from "react";
import { CheckIcon, GiftIcon, SparklesIcon } from "lucide-react";
import { SectionHeading } from "../SectionHeading";
import { SectionCta } from "../SectionCta";
import { bonuses } from "../../data/bonuses";
export function BonusesSection() {
  return <section className="bg-gold-soft px-4 py-16 sm:py-24" data-id="element-102" data-mp="qetx201qnuga">
      <div className="mx-auto max-w-4xl" data-id="element-103" data-mp="vcvbu8s4t7ly">
        <div className="flex justify-center" data-id="element-104" data-mp="vdna5rd45jfx">
          <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-navy" data-id="element-105" data-mp="1j14wh7dlzpbi">
            <GiftIcon className="h-7 w-7 text-gold" aria-hidden="true" data-id="element-106" data-mp="1o0r6l7y54pg3" />
          </span>
        </div>
        <SectionHeading eyebrow="Exclusive bonuses" title={<>
              Today, you’ll also receive <span className="text-cta-dark" data-id="element-108" data-mp="1e93nbubqmepp">5 complementary</span> hemodynamic monitoring resources
            </>} intro="Five additional educational tools designed to help you review, organize, and practice the concepts covered in the Blueprint™." data-id="element-107" data-mp="19cd633o75d2p" />

        <div className="mt-12 space-y-8" data-id="element-109" data-mp="2m6k0jk1hok6j">
          {bonuses.map(b => <article key={b.number} className="-mx-4 overflow-hidden bg-white shadow-sm sm:mx-0 sm:rounded-3xl sm:ring-1 sm:ring-line" data-id="element-110" data-mp="2h6xo3cthj7ys">
              <div className="flex items-center justify-between gap-3 bg-navy px-4 py-3 sm:px-6" data-id="element-111" data-mp="2vwv61b0tn1fj">
                <span className="text-lg font-extrabold uppercase tracking-wide text-gold" data-id="element-112" data-mp="2r30pgggij2ko">Bonus #{b.number}</span>
                <span className="flex items-center gap-2 text-sm font-bold" data-id="element-113" data-mp="34u5jn31432nm">
                  <span className="text-brand-sky line-through" data-id="element-114" data-mp="2zw406gzrx1bm">{b.value}</span>
                  <span className="rounded-md bg-cta px-2 py-1 text-xs font-extrabold uppercase tracking-wide text-white" data-id="element-115" data-mp="3eufwunn5ca2s">
                    Included today
                  </span>
                </span>
              </div>

              <img src={b.image} alt={`${b.title} mockup`} className="block aspect-[4/3] w-full object-cover" loading="lazy" data-id="element-116" data-mp="1kgop5todo09z" />

              <div className="px-5 pb-7 pt-2 sm:px-8 sm:pb-8" data-id="element-117" data-mp="1fjerjqqu4ib2">
                <h3 className="text-2xl font-extrabold leading-tight text-navy sm:text-3xl" data-id="element-118" data-mp="256itac0koy3f">{b.title}</h3>
                <p className="mt-3 text-lg font-bold leading-snug text-brand" data-id="element-119" data-mp="297b4hat09d2c">{b.headline}</p>
                <div className="mt-3 space-y-2 text-base leading-relaxed text-muted" data-id="element-120" data-mp="2e5475tv3noxv">
                  {b.intro.map(p => <p key={p} data-id="element-121" data-mp="2j2w452alq18x">{p}</p>)}
                </div>

                <h4 className="mt-6 text-sm font-extrabold uppercase tracking-wider text-navy" data-id="element-122" data-mp="2o3jzu19rz69h">You’ll receive</h4>
                <ul className="mt-3 grid gap-2.5 sm:grid-cols-2 sm:gap-x-6" data-id="element-123" data-mp="2s3ke9lwvjhgj">
                  {b.receive.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-124" data-mp="31v6zmb2xewx0">
                      <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-cta" strokeWidth={3} aria-hidden="true" data-id="element-125" data-mp="31xkqs8uhjoza" />
                      <span className="text-[15px] font-medium leading-snug text-ink" data-id="element-126" data-mp="3btnsxepc7nm8">{item}</span>
                    </li>)}
                </ul>

                <div className="mt-6 flex gap-3 rounded-2xl bg-gold-soft p-4" data-id="element-127" data-mp="107vpqzzonp1d">
                  <SparklesIcon className="mt-0.5 h-5 w-5 shrink-0 text-gold-dark" aria-hidden="true" data-id="element-128" data-mp="v66b7ad94t8j" />
                  <p className="text-base leading-snug text-ink" data-id="element-129" data-mp="q8wed9nj9fao">
                    <span className="font-extrabold" data-id="element-130" data-mp="l9jtgug82iaq">Why it’s valuable: </span>
                    {b.why}
                  </p>
                </div>
                {b.note && <p className="mt-4 text-xs leading-relaxed text-muted" data-id="element-131" data-mp="1iyv8vkkhy4mq">{b.note}</p>}
              </div>
            </article>)}
        </div>

        <p className="mt-10 text-center text-base font-semibold text-navy" data-id="element-132" data-mp="1967eewgzocr6">
          All five bonuses are included with your purchase of the Hemodynamic Monitoring Blueprint™.
        </p>
        <SectionCta label="Yes! I want all 5 bonuses included" data-id="element-133" data-mp="21ntizrw7ad35" />
      </div>
    </section>;
}